import { useEffect, useState, type HTMLAttributes, useRef } from 'react';
import { StyledFixedTopContainer } from './FixedTopContainer.styles';

export interface FixedTopContainerProps extends HTMLAttributes<HTMLDivElement> {
  reveal: boolean;
  topPx?: string | number;
  nudgeTopPx?: string | number;
}

const FixedTopContainer = ({
  children,
  topPx = 64,
  nudgeTopPx,
  ...restProps
}: FixedTopContainerProps) => {
  const ref = useRef() as React.MutableRefObject<HTMLDivElement>;
  const [nudgeDown, setNudgeDown] = useState(false);

  useEffect(() => {
    let lastScrollTop = 0;
    const footers = document.getElementsByTagName('footer');
    let footer: HTMLElement;

    if (!!footers.length) {
      footer = footers[footers.length - 1];
    }

    const watchScrollDirection = () => {
      const scrollPos = window.scrollY || document.documentElement.scrollTop;

      if (scrollPos > lastScrollTop) {
        setNudgeDown(false);
      } else if (scrollPos < lastScrollTop) {
        setNudgeDown(true);
      }

      lastScrollTop = scrollPos <= 0 ? 0 : scrollPos;
    };

    window.addEventListener('scroll', watchScrollDirection);

    return () => window.removeEventListener('scroll', watchScrollDirection);
  }, []);

  return (
    <StyledFixedTopContainer
      {...restProps}
      topPx={topPx}
      nudgeDown={nudgeDown}
      ref={ref}
    >
      {children}
    </StyledFixedTopContainer>
  );
};

export default FixedTopContainer;
